export default "__VITE_ASSET__BKzf28iX__"